import React from 'react';

// Gift / reward glyph — the single source for the "เติมชั่วโมง" (top-up) action
// across the app. stroke=currentColor so it inherits the surrounding text color.
const GiftIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-7.5-13.5h15a1.5 1.5 0 011.5 1.5v.75a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V9a1.5 1.5 0 011.5-1.5z" />
  </svg>
);

export default GiftIcon;
